export default __webpack_public_path__ + "static/media/logo-kla-beauty.251e8362.svg";